import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IQuestionnairesPayload, QuestionnairesJson } from '../Questionnaires.ts';
import { QuestionnairesApi } from '../../../apis/QuestionnairesApi/QuestionnairesApi.ts';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';

export function useGetQuestionnairesById() {
    const id = useIdFromRoute();

    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.questionnaire, id],
        queryFn: async () => {
            if (typeof id !== 'string' && typeof id !== 'number') 
                throw new Error('Invalid ID');
            
            const result: IQuestionnairesPayload = await QuestionnairesApi.getQuestionnairesById(id.toString());
            return new QuestionnairesJson(result);
        },
        enabled: !!id,
    });
}
